import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMenu, FiX, FiPhone, FiMapPin } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/about', label: 'About Us' },
    { path: '/contact', label: 'Contact Us' }
  ];

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-red-800 rounded-full flex items-center justify-center">
              <span className="text-white font-bold text-xl">S</span>
            </div>
            <span className="text-red-800 font-bold text-xl hidden sm:block">Stars Event Decor</span>
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`font-medium transition-colors duration-200 ${
                  isActive(item.path)
                    ? 'text-red-800 border-b-2 border-red-800'
                    : 'text-gray-700 hover:text-red-800'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <a
              href="tel:+14163207474"
              className="bg-red-800 text-white px-4 py-2 rounded-lg hover:bg-red-900 transition-colors duration-200 flex items-center space-x-2"
            >
              <SafeIcon icon={FiPhone} className="w-4 h-4" />
              <span>Call Now</span>
            </a>
          </nav>

          <button
            onClick={toggleMenu}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
            aria-label="Toggle menu"
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6 text-gray-700" />
          </button>
        </div>

        <AnimatePresence>
          {isMenuOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.2 }}
              className="md:hidden bg-white border-t border-gray-200"
            >
              <nav className="py-4 space-y-2">
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={closeMenu}
                    className={`block px-4 py-3 rounded-lg transition-colors duration-200 ${
                      isActive(item.path)
                        ? 'text-red-800 bg-red-50 border-l-4 border-red-800'
                        : 'text-gray-700 hover:text-red-800 hover:bg-gray-50'
                    }`}
                  >
                    {item.label}
                  </Link>
                ))}
                <div className="px-4 pt-2 space-y-2">
                  <a
                    href="tel:+14163207474"
                    className="flex items-center space-x-3 text-red-800 hover:text-red-900 transition-colors duration-200"
                    onClick={closeMenu}
                  >
                    <SafeIcon icon={FiPhone} className="w-5 h-5" />
                    <span>+1 (416) 320-7474</span>
                  </a>
                  <a
                    href="https://maps.app.goo.gl/PAVpvEhCYvxFP7aA"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center space-x-3 text-gray-600 hover:text-red-800 transition-colors duration-200"
                    onClick={closeMenu}
                  >
                    <SafeIcon icon={FiMapPin} className="w-5 h-5" />
                    <span className="text-sm">Scarborough, ON</span>
                  </a>
                </div>
              </nav>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </header>
  );
};

export default Header;